require('./RASetGoalStep1.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const RAImageButton = require('../../commons/RAImageButton/RAImageButton');
const RAImageButtonGroup = require('../../commons/RAImageButtonGroup/RAImageButtonGroup');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @components
const RASetGoalStepHeader = require('../RASetGoalStepHeader/RASetGoalStepHeader');

// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');

class RASetGoalStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleGetImageClicked = this.handleGetImageClicked.bind(this);
    }

    handleGetImageClicked(goalSelected) {
        const { updateGoalSelected } = this.props;
        updateGoalSelected(goalSelected);
    }

    buildImageButtons(goalsList, initialIconState) {
        const { immSteps } = this.props;
        const goalSelectedFlagForRadio = immSteps.getIn([
            FIRST_STEP,
            'goalSelectedFlagForRadio',
        ]);
        let isSelected, extraClassForGoalWrapper;

        const content = goalsList.map((content, index) => {
            const titleKey = content.get('title');
            const title = formatText(titleKey);
            const id = content.get('id');
            const extraClass = !initialIconState
                ? 'ra-set-goal-step1__col-header__icon'
                : '';
            if (!goalSelectedFlagForRadio) {
                isSelected = goalSelectedFlagForRadio;
                extraClassForGoalWrapper = 'ra-set-goal-step1__icon';
            } else {
                isSelected = content.get('isSelected');
            }

            return (
                <RAImageButton
                    label={title}
                    iconType={id}
                    extraClass={extraClass}
                    id={id}
                    key={title + `-` + index}
                    isSelected={isSelected}
                    extraClassForGoalWrapper={extraClassForGoalWrapper}
                />
            );
        });

        return content;
    }

    render() {
        const { immSteps } = this.props;
        const goalsList = immSteps.getIn([FIRST_STEP, 'goals']);
        const validStep = immSteps.getIn([FIRST_STEP, 'goalSelected']);
        const isAmountDirty = !!immSteps.getIn([
            SECOND_STEP,
            'investmentAmount',
        ]);
        let content;

        if (goalsList && !goalsList.isEmpty()) {
            content = this.buildImageButtons(goalsList, validStep);
        }

        return (
            <div className="ra-set-goal-step1">
                <RASetGoalStepHeader
                    title={formatText('raSetGoal-step1HeaderTitle')}
                    description={formatText('raSetGoal-step1HeaderDescription')}
                    active={validStep}
                    resetStep={this.props.resetStep}
                    showButton={isAmountDirty}
                />
                <div className="row">
                    <div className="col-md-12">
                        <div className="ra-set-goal-step1__col-header">
                            <RAImageButtonGroup
                                onChange={this.handleGetImageClicked}
                            >
                                {content}
                            </RAImageButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RASetGoalStep1.propTypes = {
    active: PropTypes.bool.isRequired,
    immSteps: PropTypes.object.isRequired,
    resetStep: PropTypes.func.isRequired,
    selectedGoal: PropTypes.func,
    updateGoalSelected: PropTypes.func,
};

module.exports = RASetGoalStep1;
